import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  activeButton: {
    fontType: 'Roboto',
    fontWeight: 500,
    fontSize: '13px',
    minWidth: '212px',
    height: '30px',
    lineHeight: '22px',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#266733',
    },
    borderRadius: '4px',
    boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)',
    alignItems: 'center',
  },
  disableButton: {
    fontType: 'Roboto',
    fontWeight: 500,
    fontSize: '13px',
    height: '30px',
    lineHeight: '22px',
    color: '#FFFFFF',
    minWidth: '212px',
    backgroundColor: '#6F707B',
    borderRadius: '4px',
    alignItems: 'center',
    boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)',
    cursor: 'not-allowed',
    pointerEvents: 'all',
    '&:hover': {
      backgroundColor: '#575861',
    },
  },
  assignRGZ: {
    minWidth: '144px',
    margin: '8px',
  },
  alreadyAssigned: {
    display: 'flex',
    color: '#347F42',
    margin: '8px',
  },
}));
